import React, { useContext, useMemo } from 'react'
import Table from 'react-bootstrap/Table'
import { twoDigitMoney } from 'helpers/utils'
import UserContext from 'context/user-context'
import { titleize } from 'helpers/utils'

function Allocations({ allocations, sectionName }) {
  const { municipality, municipality_sections } = useContext(UserContext)

  // Find the current section's system
  const currentSection = useMemo(() => {
    if (!municipality_sections || !sectionName) return null
    return municipality_sections.find(
      (ms) => ms.section?.name === sectionName
    )
  }, [municipality_sections, sectionName])

  // Check if the system is Enterprise ERP
  const isEnterpriseERP = useMemo(() => {
    return currentSection?.system?.name === 'Enterprise ERP'
  }, [currentSection])

  // Helper function to get custom segment name or fallback
  const getSegmentName = (segmentNumber) => {
    const segmentKey = `seg_${segmentNumber}_name`
    return municipality?.setting?.[segmentKey] || `Segment ${titleize(segmentNumber)}`
  }

  // Helper function to render segment cell
  const renderSegmentCell = (allocation, segmentNumber) => {
    const nameKey = `seg_${segmentNumber}_name`
    const codeKey = `seg_${segmentNumber}_code`
    const name = allocation.account?.[nameKey]
    const code = allocation.account?.[codeKey]

    if (!name && !code) return null

    return (
      <td>
        {name && code ? `${name} (${code})` : name || code || ''}
      </td>
    )
  }

  return (
    <div className="w-100">
      <Table className="border border-light" size="sm">
        <thead className="border-bottom border-light">
          <tr>
            {isEnterpriseERP ? (
              <>
                <th>Org</th>
                <th>Obj</th>
              </>
            ) : (
              <>
                <th>{getSegmentName('one')}</th>
                <th>{getSegmentName('two')}</th>
                <th>{getSegmentName('three')}</th>
                <th>{getSegmentName('four')}</th>
                <th>{getSegmentName('five')}</th>
              </>
            )}
            <th>Line</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {allocations.map((a) => (
            <tr key={`allocations-${a.id}`}>
              {isEnterpriseERP ? (
                <>
                  <td>
                    {a.org?.name} ({a.org?.code})
                  </td>
                  <td>
                    {a.object?.name} ({a.object?.code})
                  </td>
                </>
              ) : (
                <>
                  {renderSegmentCell(a, 'one')}
                  {renderSegmentCell(a, 'two')}
                  {renderSegmentCell(a, 'three')}
                  {renderSegmentCell(a, 'four')}
                  {renderSegmentCell(a, 'five')}
                </>
              )}
              <td>{a.line}</td>
              <td>{twoDigitMoney(a.amount)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default Allocations
